var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.4086 -2.58521e-08L11.5 10.5089L0.591431 -9.7951e-07L0 -1.00536e-06L11.5 11L23 0L22.4086 -2.58521e-08Z","fill":"black"}));
}

ArrowInline.defaultProps = {"width":"23","height":"11","viewBox":"0 0 23 11","fill":"none"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
